import { useValidation } from "hooks/useValidation";
import PropTypes from "prop-types";
import React, { useEffect } from "react";

export function TemplateBuilderDecimalPreview(props) {
    const [isValid, errors, validate] = useValidation();

    const inputStep = Math.pow(10, - (props.question.numberOfDecimalPlaces));

    useEffect(() => {
        if (!props.disabled) {
            const rule = { fieldName: "answer", maxValue: props.question.maxValue, minValue: props.question.minValue, numberOfDecimalPlaces: props.question.numberOfDecimalPlaces };

            validate([rule], props.answer)
        }
    }, [props.answer, props.disabled]);

    useEffect(() => {
        if (props.answer && !isValid !== props.answer.notValid) {
            props.onChange({
                ...props.answer,
                notValid: !isValid,
                error: errors.answer
            });
        }
    }, [isValid])

    const onChange = (newValue) => {
        props.onChange({
            ...props.answer,
            $answerType: "Decimal",
            questionId: props.question.id,
            answer: +newValue,
            isAnswered: newValue != null && newValue !== '',
            error: errors.answer
        });
    }    

    return <div className="check-preview-form-field">
        <div className="check-preview-input-container">
            <input
                min={props.question.minValue}
                max={props.question.maxValue}
                value={props.answer?.answer ? props.answer.answer : ""}
                onChange={(event) => onChange(event.target.value)}
                type="number"
                step={inputStep}
                disabled={props.disabled}
            ></input>
            {props.deleteComponent}
        </div>
        {props.addAnotherComponent}
    </div>
}

TemplateBuilderDecimalPreview.propTypes = {
    answer: PropTypes.object,
    question: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
    addAnotherComponent: PropTypes.node.isRequired,
    deleteComponent: PropTypes.node.isRequired
};